import { useMutation } from "react-query";
import { post } from "shared/data";

export const useAddStandardSla = () => {
    return useMutation("clientStandardSla", {
        mutationFn: (payload) => post("/sla/client/standard", payload),
    });
};
